module.exports = __webpack_public_path__ + "static/UI_UX-d22f281c1a095b789f8ffb370bf00791.png";